import React, { useEffect } from 'react'
import { withRouter } from 'react-router-dom';
import {Box,Button, Text,Tag } from 'grommet';
import {DocumentDownload } from 'grommet-icons';
import GetS3Document from '../../components/getS3Document'
import { NavigationSnackBar, ReturnRowDir } from '../../components/utils/shared/shared';
import { ReturnLocation,ReturnCollectionDetails,ReturnTotalWeight, ShipmentSuccessNotification, StatusChip } from '../../components/utils/shared/shipmentViewFunctions';

function returnPages(user){
  if (user === 'Agent'){
    return []
  } else {
    return [{name: 'Dashboard', link:'/dashboard'},{name: 'Create Shipment', link: '/shipment/new'}]
  }
}


function ShipmentSuccess(props) {
    const [open, setOpen] = React.useState();
    useEffect(() => {setOpen(true); 
        setTimeout(() => {
        setOpen(undefined);
    }, 5000);},[]);
  const shipment = props.location.state.shipment
  const totalWeight = ReturnTotalWeight(shipment.shipment)
  const pieceDetails = props.location.state.pieceDetails
  return (
      <Box>
        <NavigationSnackBar title={`Shipment ${shipment.shipment.id}`} user={props.user} pages={returnPages(props.user)}  />
        <Box>
          <Box direction='row' justify='between' margin={'small'}><Box direction='row' margin='xsmall'><Tag  background='brand' size='small' name="AWB Number" value={shipment.shipment.awb_number} /></Box><StatusChip shipment={shipment.shipment} label='status' /></Box>
        <Box direction='column' justify="center" margin='small' align='center'>
        {open && (<ShipmentSuccessNotification label={"Shipment"}/>)}
                
                <Box direction={ReturnRowDir(props.size)} gap='small' justify='center'>
                <ReturnLocation location={shipment.shipment.origin} locationType={'Origin'}/>
                <ReturnCollectionDetails props={props} shipment={shipment.shipment} totalWeight={totalWeight}/>
                <ReturnLocation location={shipment.shipment.destination} locationType={'Destination'}/>
                </Box>
            <Box round elevation='medium' margin={{top:'medium'}} background={'background-front'} pad='small'>
            <Box direction='row'><DocumentDownload color='brand' style={{marginTop:10}} /><Text weight={'bold'} margin={'small'}>Shipment Documents</Text></Box>  
            <Box direction="row-responsive" justify='center'>
                <a rel="noopener noreferrer" target="_blank" href={shipment.AWBDocument}><Button margin="small" icon={<DocumentDownload color='status-ok'/>} label={"AWB"} type='button'/></a>
                <a rel="noopener noreferrer" target="_blank" href={shipment.CommericalInvoiceDocument}><Button margin="small" icon={<DocumentDownload color='status-ok'/>} label={"Commerical Invoice"} type='button'/></a>
                <GetS3Document commodity={pieceDetails.commodity} />
            </Box>
            </Box>
      </Box>
      </Box>
    </Box>
  )
}

export default withRouter(ShipmentSuccess)
